import { render } from "./ImportExportLayout.vue?vue&type=template&id=12cc3669"
import script from "./ImportExportLayout.vue?vue&type=script&lang=js"
export * from "./ImportExportLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__